import { useContext, useState } from 'react';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import ServicePageSelection from './ServicePageSelection';
import ServicePageClaim from './ServicePageClaim';

const ServicePagesClaimSelection = () => {
  const { currentStep } = useContext(ClaimContext);
  const [servicePage, setServicePage] = useState(null);

  switch (currentStep) {
    case 1:
      return <ServicePageSelection setServicePage={setServicePage} />;
    case 2:
      return <ServicePageClaim servicePage={servicePage} />;

    default:
      return <></>;
  }
};

export default ServicePagesClaimSelection;
